import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-terms-conditions",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./terms-conditions.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./terms-conditions.component.scss",
})
export class TermsConditionsComponent {}
